import React from 'react';

const breadcrumbContext = React.createContext(null);

export default breadcrumbContext;
